export default {
  omrBounds: {
    type: "FeatureCollection",
    name: "omr_bounds_polygon_v2",
    crs: {
      type: "name",
      properties: {
        name: "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    features: [
      {
        type: "Feature",
        properties: {
          fid: 1,
          handle: 85,
          block: -1,
          etype: 25,
          space: 0,
          layer: "GPLD3LOT$LAND_LINES",
          olinetype: "BYLAYER",
          linetype: "",
          color: "255,0,0,254",
          ocolor: 256,
          color24: -1,
          transparency: 0,
          lweight: -1,
          linewidth: 0.5,
          ltscale: 1.0,
          visible: 1,
          width: 0.0,
          thickness: 0.0,
          ext: "(3:0,0,1)"
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-106.552215433181175, 52.184391804386614],
                [-106.552252984788197, 52.184359878128056],
                [-106.55229824025821, 52.184432618218224],
                [-106.552345025488592, 52.184504383955741],
                [-106.552393319507232, 52.184575143173781],
                [-106.552443100659715, 52.184644864155409],
                [-106.552494346641595, 52.184713515648568],
                [-106.552547034483837, 52.184781066886089],
                [-106.552601140572605, 52.184847487592222],
                [-106.553292128236265, 52.185685150257711],
                [-106.554290807351919, 52.186895753708924],
                [-106.554488352631139, 52.187115465702647],
                [-106.554696974116794, 52.187324689445589],
                [-106.554916115743239, 52.187522867267027],
                [-106.555145193393386, 52.187709470934344],
                [-106.555383596476148, 52.187884003070351],
                [-106.555630689552615, 52.188045998470244],
                [-106.555885814011972, 52.188195025346424],
                [-106.555139200399282, 52.188690286487159],
                [-106.555315108578498, 52.188793861587051],
                [-106.555517836465796, 52.188900307164474],
                [-106.555707131977385, 52.188993908942741],
                [-106.555921892186234, 52.189093804625728],
                [-106.556246330585253, 52.189232983609926],
                [-106.556123224994806, 52.189346853374637],
                [-106.555969793158397, 52.189472520818867],
                [-106.555792061226882, 52.189609244017319],
                [-106.555620127176397, 52.189733438209217],
                [-106.555421446434778, 52.189868113826648],
                [-106.555188264783027, 52.190015353276394],
                [-106.554999267621156, 52.190126958771536],
                [-106.554740540190522, 52.19026959992506],
                [-106.555132078562153, 52.190548623258486],
                [-106.555375157076085, 52.190415226287826],
                [-106.555574528468796, 52.190298663523308],
                [-106.555830721246167, 52.190138429210265],
                [-106.556062947816173, 52.189981892546243],
                [-106.556298050247534, 52.189811034241792],
                [-106.556517277685273, 52.189638894835554],
                [-106.556761692569097, 52.189429971795533],
                [-106.556892834577681, 52.189472661075001],
                [-106.557075882998717, 52.189532246528529],
                [-106.557317903170116, 52.189605843202614],
                [-106.557595395296232, 52.189683276749037],
                [-106.557866956178543, 52.189752187387526],
                [-106.558097772805397, 52.189805630225422],
                [-106.558637136979343, 52.189912986932768],
                [-106.558836253684561, 52.189946649585487],
                [-106.559155925773993, 52.189994198450144],
                [-106.559499419146292, 52.190036584271695],
                [-106.559866260660996, 52.190072130601045],
                [-106.560253129111388, 52.19009895712815],
                [-106.560740099913104, 52.19011931771297],
                [-106.560789286327775, 52.189617039244737],
                [-106.562108254892294, 52.189665820608404],
                [-106.563161621807126, 52.189704764690191],
                [-106.563161635552603, 52.18963722279932],
                [-106.565819128512985, 52.189735431162859],
                [-106.565885717964619, 52.189805319597575],
                [-106.566370214231355, 52.189816785406457],
                [-106.566433049015373, 52.189758110179461],
                [-106.569009974061728, 52.189853269975067],
                [-106.569024719139648, 52.189876232698523],
                [-106.569429985797044, 52.189891288633063],
                [-106.56944201954289, 52.189869218845942],
                [-106.569704478304772, 52.189878906682836],
                [-106.569696585998358, 52.189959673892929],
                [-106.574918162169865, 52.190152289414883],
                [-106.574925368277619, 52.190177754351005],
                [-106.574936465722615, 52.190219728200702],
                [-106.57494542142598, 52.190270342645626],
                [-106.57495285760298, 52.19033010853083],
                [-106.574954141685467, 52.19035202521755],
                [-106.574954879457522, 52.190410292862467],
                [-106.575245959830113, 52.190421023331162],
                [-106.575247228549514, 52.190350564920763],
                [-106.575249685654313, 52.190313959044296],
                [-106.575255653015759, 52.190269982873374],
                [-106.575263397055352, 52.190230250113515],
                [-106.575275773817921, 52.190178980537134],
                [-106.581939795180006, 52.190424438866408],
                [-106.58378662715657, 52.190492398910507],
                [-106.584243206824141, 52.190513560825572],
                [-106.58469925436583, 52.190544113437682],
                [-106.585154576656336, 52.190584043812116],
                [-106.585608980880338, 52.190633335034356],
                [-106.586062274606945, 52.190691966235136],
                [-106.586514265880652, 52.190759912583168],
                [-106.586964763304522, 52.190837145307661],
                [-106.586964204965753, 52.191052689904296],
                [-106.587151219153867, 52.191088742247814],
                [-106.587591739618944, 52.191180881704732],
                [-106.588200562491792, 52.191325468448134],
                [-106.588683010501995, 52.191454930101209],
                [-106.589092399103293, 52.191575655712001],
                [-106.589451197380313, 52.191690072206491],
                [-106.589658063753134, 52.191453629783204],
                [-106.590094427024908, 52.191602591082642],
                [-106.590526353644464, 52.191763965695849],
                [-106.590953490580418, 52.191937621722893],
                [-106.59137548868965, 52.192123417222312],
                [-106.591792003051751, 52.192321200330319],
                [-106.592202693223683, 52.192530809386312],
                [-106.592607223517021, 52.192752073061115],
                [-106.592832373948369, 52.192880968253455],
                [-106.592832334682925, 52.193016084996316],
                [-106.59449859304685, 52.193969952565631],
                [-106.594482087789928, 52.193984840758695],
                [-106.594513837879532, 52.194077989903811],
                [-106.594745941153079, 52.194210380052411],
                [-106.594748179028898, 52.194210349801011],
                [-106.594767475692052, 52.194213292664507],
                [-106.59478789586403, 52.194218047009933],
                [-106.594809297071521, 52.194225124285431],
                [-106.594823374499782, 52.194231196072423],
                [-106.594838877580074, 52.194239518800643],
                [-106.594886022233453, 52.194266474537216],
                [-106.594946681743934, 52.194226454672538],
                [-106.595948765336161, 52.194800066377795],
                [-106.596209971269118, 52.194800935258911],
                [-106.596853898680322, 52.19516951646812],
                [-106.597149280149594, 52.195333545160352],
                [-106.597447975082972, 52.19549145957442],
                [-106.597749856933646, 52.195643192806521],
                [-106.598054797803329, 52.195788680572143],
                [-106.598362668500116, 52.195927861231191],
                [-106.598673338596697, 52.19606067582437],
                [-106.598986676468996, 52.19618706807811],
                [-106.598986712363157, 52.196250960506866],
                [-106.599883981232878, 52.196570863254479],
                [-106.600794264835471, 52.196851599707742],
                [-106.601715854427297, 52.197092642878481],
                [-106.602647020052231, 52.197293540293678],
                [-106.603586013766957, 52.197453914836814],
                [-106.604531072936979, 52.197573465460906],
                [-106.605480423547235, 52.197651967755135],
                [-106.605680663325202, 52.19766452674893],
                [-106.605880999064112, 52.197675448772308],
                [-106.606081417376103, 52.19768473309886],
                [-106.606281904871125, 52.197692379106222],
                [-106.606482448161415, 52.197698386283257],
                [-106.606683033850587, 52.197702754228239],
                [-106.606883648538684, 52.197705482652289],
                [-106.606879745316192, 52.19785822838756],
                [-106.608524941081228, 52.197863210472875],
                [-106.608526013040219, 52.197710447372799],
                [-106.609881032272924, 52.197714029900204],
                [-106.609881425012475, 52.197660202398986],
                [-106.610793853189847, 52.197662606005338],
                [-106.61079325247249, 52.198022180402312],
                [-106.613146575428644, 52.198028346986497],
                [-106.613145334400983, 52.198207861939267],
                [-106.615257121338928, 52.198213355561798],
                [-106.615090336213029, 52.198081882552295],
                [-106.61504382592085, 52.198033077548047],
                [-106.614961540723343, 52.197946732260299],
                [-106.614796306095371, 52.197748033098421],
                [-106.614692047696082, 52.197630915622327],
                [-106.614593619405824, 52.197557561016389],
                [-106.614543230531581, 52.197380065260788],
                [-106.614461499792768, 52.197324214554847],
                [-106.614310663155621, 52.1972225869658],
                [-106.614232111897309, 52.19713119278925],
                [-106.614144779218464, 52.196981176973864],
                [-106.613969510370893, 52.196771977255473],
                [-106.613958705782707, 52.196771949121931],
                [-106.610795324977275, 52.19676366983898],
                [-106.610794739666673, 52.197123244328253],
                [-106.609885176665856, 52.197120848167721],
                [-106.609886620061587, 52.196914257525435],
                [-106.606904069097595, 52.196906350951203],
                [-106.606898804681649, 52.197112368237889],
                [-106.605503754064543, 52.197071676326289],
                [-106.604115043899654, 52.196932729789253],
                [-106.602739585701769, 52.196696220147707],
                [-106.60138422503222, 52.196363324495898],
                [-106.600055707424033, 52.195935699629402],
                [-106.598760644814305, 52.195415473810556],
                [-106.597505482641182, 52.194805236168577],
                [-106.597529229708684, 52.194805314868454],
                [-106.595520101748079, 52.193655374660807],
                [-106.595530829138724, 52.193635729018368],
                [-106.595542980637177, 52.193617382901202],
                [-106.595560593145336, 52.193597897184766],
                [-106.595593396248731, 52.193564685274787],
                [-106.59563705011341, 52.193523968126733],
                [-106.59565647284154, 52.1935066547655],
                [-106.595385650554434, 52.193351594842241],
                [-106.595352671156178, 52.193368842477433],
                [-106.595299107691773, 52.193395218770341],
                [-106.595255717772631, 52.193415264771822],
                [-106.595207446528477, 52.193436593261389],
                [-106.595171138493598, 52.193450702135159],
                [-106.59516575267179, 52.193452550363538],
                [-106.59424083058633, 52.192923124457401],
                [-106.594678512151461, 52.19263436165398],
                [-106.593665048037039, 52.192054185847702],
                [-106.593547767211476, 52.191987765748138],
                [-106.593429932534278, 52.191922333257935],
                [-106.593311552322106, 52.19185789299808],
                [-106.593192634929423, 52.191794449514411],
                [-106.593073188749045, 52.191732007283463],
                [-106.592953222208507, 52.191670570716099],
                [-106.592832743781287, 52.19161014414555],
                [-106.592832593915261, 52.192124791085341],
                [-106.592765027857084, 52.192088976932105],
                [-106.592697289159474, 52.192053490382932],
                [-106.592629379421837, 52.192018332267246],
                [-106.592561300225483, 52.191983503411386],
                [-106.592493053171125, 52.191949004628441],
                [-106.592424639864319, 52.19191483673098],
                [-106.592356061901128, 52.191881000521697],
                [-106.592356054714458, 52.191026556840448],
                [-106.59192002030909, 52.190841735641875],
                [-106.591343625040494, 52.190616514344725],
                [-106.591066847537462, 52.190515637501193],
                [-106.590764405954701, 52.190410537510104],
                [-106.590321432004572, 52.190265887559619],
                [-106.589920343171386, 52.190144040106482],
                [-106.589637125352724, 52.190063026034395],
                [-106.589969409227308, 52.189612937455465],
                [-106.589458134771135, 52.189476529004772],
                [-106.588709243547129, 52.189298258289817],
                [-106.58821650230432, 52.189194336251397],
                [-106.587798262044373, 52.18911415902496],
                [-106.587280814420268, 52.189024894144936],
                [-106.586970807348052, 52.188978284923337],
                [-106.586966662514456, 52.190126888916126],
                [-106.586524768495025, 52.190056896960776],
                [-106.586081649226529, 52.189995135216122],
                [-106.585637457985271, 52.189941625047133],
                [-106.585192348411496, 52.189896384961678],
                [-106.584746474464467, 52.189859430604884],
                [-106.584299990375172, 52.189830774764594],
                [-106.58385305057854, 52.189810427347574],
                [-106.582732184163305, 52.189769184845098],
                [-106.582612885296427, 52.18964835750122],
                [-106.5826589865393, 52.189073069485737],
                [-106.583041116448598, 52.187532173240186],
                [-106.583210165216173, 52.186850469906702],
                [-106.583237195108737, 52.186750367983969],
                [-106.583267705184767, 52.186651271334071],
                [-106.583301658207333, 52.186553300916778],
                [-106.583339012726341, 52.186456576308039],
                [-106.58337972315428, 52.186361215563906],
                [-106.583423739802598, 52.186267335082285],
                [-106.583471008944557, 52.186175049444977],
                [-106.583629235346095, 52.186076883758695],
                [-106.583802091221841, 52.185819559630666],
                [-106.583888099804341, 52.185686644038803],
                [-106.583863130666785, 52.185588084192318],
                [-106.584013267886448, 52.185416549769535],
                [-106.58417102619994, 52.185251997166198],
                [-106.584336081294154, 52.185094764661692],
                [-106.584508093852477, 52.184945175482419],
                [-106.584686710270645, 52.18480353714309],
                [-106.584871563358874, 52.184670140819172],
                [-106.585062273108662, 52.18454526073365],
                [-106.58609798267851, 52.183883654929836],
                [-106.586122324022128, 52.183891929788743],
                [-106.586506195348107, 52.183694173397051],
                [-106.586697358779261, 52.183635091542122],
                [-106.587103308177063, 52.18337066670999],
                [-106.587130098126948, 52.183224316633336],
                [-106.588931546821811, 52.182073443218925],
                [-106.589036997732634, 52.18207871974343],
                [-106.589296271817034, 52.181920411824606],
                [-106.589293483337428, 52.181842206054299],
                [-106.590988821087606, 52.180759027446292],
                [-106.591279734642796, 52.180680216021464],
                [-106.591723885864141, 52.180405773485333],
                [-106.591769474974299, 52.180260229376756],
                [-106.593563820922554, 52.179113672193893],
                [-106.593709524449864, 52.179111703689742],
                [-106.593984542017239, 52.178943050256841],
                [-106.593964791225318, 52.178857447132316],
                [-106.595668934078788, 52.177768430670682],
                [-106.595923457183304, 52.177704968824429],
                [-106.596401978878973, 52.177419385265971],
                [-106.596452912324537, 52.177267410795366],
                [-106.597126478915115, 52.176836939024639],
                [-106.597276327623547, 52.176739096480148],
                [-106.597423201486023, 52.176636842538777],
                [-106.597566970671309, 52.176530267583068],
                [-106.597707508099106, 52.176419465820793],
                [-106.597844689543351, 52.176304535188159],
                [-106.597978393752271, 52.176185577277053],
                [-106.598108502534572, 52.176062697238621],
                [-106.598385552426791, 52.176169144411006],
                [-106.598487261663507, 52.176069101587778],
                [-106.598608315817103, 52.175938993631007],
                [-106.598707071989253, 52.175825548852174],
                [-106.598708075865048, 52.175659840185212],
                [-106.598519289646205, 52.175604044362501],
                [-106.598599890401388, 52.175498284433331],
                [-106.598676791154745, 52.175389804392594],
                [-106.598749900182142, 52.175278733626321],
                [-106.598819130285833, 52.175165204609577],
                [-106.598884398890974, 52.175049352747934],
                [-106.598945628154766, 52.174931316221034],
                [-106.599002745053298, 52.17481123581166],
                [-106.599002917837169, 52.174629637745042],
                [-106.599056211718434, 52.174481504909878],
                [-106.599101659472097, 52.174330779743293],
                [-106.599139135894788, 52.174177877512186],
                [-106.599168537726641, 52.174023219482471],
                [-106.599189783960782, 52.173867231750599],
                [-106.599202816068882, 52.173710344088491],
                [-106.599207598140254, 52.173552988739338],
                [-106.599208087160449, 52.173125783089041],
                [-106.599226241393325, 52.173125863825653],
                [-106.599224752338102, 52.17294538800418],
                [-106.599208293765926, 52.172945315307253],
                [-106.599135017834314, 52.172944992763114],
                [-106.599137157565181, 52.171093814884863],
                [-106.599139280813276, 52.169258161137037],
                [-106.599139520641984, 52.169167777097691],
                [-106.59913958138857, 52.169096306901707],
                [-106.599140002031433, 52.168634278407779],
                [-106.599135921132273, 52.167157335782015],
                [-106.599131880890781, 52.165694634754942],
                [-106.599124796924841, 52.164968493816886],
                [-106.599121990019412, 52.164684927072202],
                [-106.599120097705523, 52.164493752268562],
                [-106.599119841597897, 52.164467877480256],
                [-106.599112143769418, 52.163690151638626],
                [-106.599114116641232, 52.161904629237519],
                [-106.599116013907491, 52.160114193723388],
                [-106.59909658933563, 52.159612082565161],
                [-106.599077336200182, 52.158437346365453],
                [-106.599072967226491, 52.158437295502509],
                [-106.599073990391304, 52.157825407720836],
                [-106.59907851707024, 52.155766201445871],
                [-106.599078836686104, 52.155527147531814],
                [-106.599077686232846, 52.155429707832234],
                [-106.598976510214456, 52.155429884782599],
                [-106.598979271218155, 52.153784196224002],
                [-106.599009815442216, 52.153275695878321],
                [-106.599028549572694, 52.152935868669061],
                [-106.599033399877172, 52.152601611671102],
                [-106.599037790034401, 52.152512002490987],
                [-106.599059586815343, 52.15237590793943],
                [-106.59902690061962, 52.152375629401277],
                [-106.599030545221922, 52.152150893006954],
                [-106.599032043017317, 52.151307474975511],
                [-106.598886679374928, 52.151281729768876],
                [-106.598609430848754, 52.151281579443229],
                [-106.598604787701106, 52.151278202066571],
                [-106.598600072285819, 52.151274926341117],
                [-106.598595286835902, 52.151271753815301],
                [-106.59859043359755, 52.151268685982352],
                [-106.598585514869967, 52.151265724290184],
                [-106.598580532972619, 52.151262870139583],
                [-106.598575490250425, 52.151260124875712],
                [-106.598539395835743, 52.151276706497661],
                [-106.598540232238463, 52.151281541814882],
                [-106.598525534660027, 52.151281533815485],
                [-106.598528930237634, 52.15130116382857],
                [-106.598535672868977, 52.151305051534223],
                [-106.598542167776444, 52.151309340294638],
                [-106.598548391146309, 52.151314014377924],
                [-106.598554320138632, 52.151319056636559],
                [-106.598559933008787, 52.151324448577718],
                [-106.598565209165812, 52.151330170419889],
                [-106.598570129259301, 52.151336201173756],
                [-106.598574675241238, 52.151342518720405],
                [-106.598578830428281, 52.151349099883255],
                [-106.598582579592559, 52.151355920522406],
                [-106.598585908968872, 52.151362955618204],
                [-106.598598713553571, 52.151398936027249],
                [-106.59860961507853, 52.151435537994082],
                [-106.59861858359362, 52.151472660940264],
                [-106.59862559444808, 52.151510202851561],
                [-106.598630628378814, 52.151548060567627],
                [-106.59863367155404, 52.151586130062128],
                [-106.598634715611283, 52.151624306719313],
                [-106.598633776716923, 52.152150667624781],
                [-106.59863246252668, 52.152887529729576],
                [-106.598632437988272, 52.152901286056071],
                [-106.598632330966481, 52.152961304599678],
                [-106.598586468757361, 52.153578557301337],
                [-106.598584495700649, 52.15360709687593],
                [-106.59858281700852, 52.15363565527786],
                [-106.598581432855994, 52.153664229470444],
                [-106.598580343394119, 52.153692816413233],
                [-106.598579548735671, 52.153721413070336],
                [-106.598579048962435, 52.153750016399499],
                [-106.598578844133272, 52.153778623363792],
                [-106.598577563312872, 52.154425312138557],
                [-106.598577125245512, 52.15444464558454],
                [-106.598575935192457, 52.154463947338627],
                [-106.598573994953753, 52.154483188167426],
                [-106.598571307466031, 52.154502338922605],
                [-106.598567876800189, 52.154521370593102],
                [-106.598563708157755, 52.154540254354238],
                [-106.598558807854047, 52.154558961598454],
                [-106.598546028949642, 52.154604481162799],
                [-106.598540349050339, 52.154626164494445],
                [-106.598535517209697, 52.154648052423902],
                [-106.598531540756071, 52.154670111796797],
                [-106.598528425700337, 52.154692309197337],
                [-106.598526176764594, 52.154714610999683],
                [-106.598524797363964, 52.154736983424343],
                [-106.598524289578094, 52.154759392580864],
                [-106.598523739169536, 52.155037186705158],
                [-106.598522858636002, 52.155056006447964],
                [-106.598520596794387, 52.155074710516615],
                [-106.598516965885196, 52.155093197663511],
                [-106.598511985564969, 52.155111367817874],
                [-106.598505682791128, 52.155129122621489],
                [-106.598498091676461, 52.155146365970765],
                [-106.598489253320253, 52.155163004526855],
                [-106.598486529533886, 52.155167481573883],
                [-106.598483597125949, 52.15517182484021],
                [-106.598480462660504, 52.155176024612949],
                [-106.598477133142282, 52.155180071498755],
                [-106.598473616018225, 52.155183956444517],
                [-106.598469919155662, 52.155187670766466],
                [-106.598466050824442, 52.155191206154313],
                [-106.598471892265977, 52.155250043900864],
                [-106.598472841625608, 52.155267299924908],
                [-106.59843968983057, 52.155279092644911],
                [-106.598397982787546, 52.155290934871744],
                [-106.598350483828384, 52.155300956219158],
                [-106.598312775744958, 52.155306533514917],
                [-106.598244389704249, 52.155311677269623],
                [-106.598238626255693, 52.155311827714954],
                [-106.598238019417508, 52.155449997785794],
                [-106.598317670170232, 52.15545709148811],
                [-106.598399394865055, 52.155470319003577],
                [-106.598454329815681, 52.155483023177268],
                [-106.598471505848593, 52.155488159352103],
                [-106.598474239260554, 52.155513530698002],
                [-106.598482954341279, 52.15556900516841],
                [-106.598491585552523, 52.155574449830254],
                [-106.598499821280726, 52.155580476018308],
                [-106.598507622416932, 52.155587055116477],
                [-106.598514951903766, 52.155594155876308],
                [-106.598521774936685, 52.155601744575556],
                [-106.598528059116774, 52.155609785176438],
                [-106.598533774594415, 52.155618239493755],
                [-106.598542302558783, 52.15563324314499],
                [-106.598549916376001, 52.155648730738008],
                [-106.598556588702181, 52.155664646637881],
                [-106.598562295563156, 52.15568093367073],
                [-106.598567016462752, 52.155697533333289],
                [-106.598570734444351, 52.155714385999083],
                [-106.598573436149096, 52.155731431131258],
                [-106.598575111874382, 52.155748607500215],
                [-106.598575755599342, 52.155765853407992],
                [-106.598571547220658, 52.157670471086838],
                [-106.598570987478823, 52.157692108636191],
                [-106.598569480400172, 52.157713700894419],
                [-106.598567028879174, 52.157735206405043],
                [-106.598563637624451, 52.1577565838761],
                [-106.598559313144349, 52.157777792263914],
                [-106.598554063739655, 52.15779879084949],
                [-106.598547899493894, 52.157819539319853],
                [-106.598540045842469, 52.157846058980731],
                [-106.598533418560834, 52.157872911378028],
                [-106.598528031638111, 52.157900039837834],
                [-106.59852389643855, 52.157927387092052],
                [-106.598521021689663, 52.157954895416871],
                [-106.59851941346767, 52.157982506752823],
                [-106.598519075162287, 52.158010162812943],
                [-106.598517854893217, 52.158157359420251],
                [-106.598517600229343, 52.158272247946805],
                [-106.598516708173577, 52.158291067719951],
                [-106.598514437110538, 52.158309771245527],
                [-106.598510799292839, 52.158328257617534],
                [-106.598505814352379, 52.158346427097051],
                [-106.59849950917382, 52.158364181656921],
                [-106.598491917785452, 52.158381425507436],
                [-106.598483081135441, 52.158398065618265],
                [-106.598480023206051, 52.158403035667504],
                [-106.598476713697053, 52.158407841855507],
                [-106.598473161364367, 52.158412471460899],
                [-106.598469375610861, 52.158416912227032],
                [-106.598465366462804, 52.15842115239596],
                [-106.59846114452985, 52.158425180746633],
                [-106.598456720991607, 52.158428986614162],
                [-106.598460093808399, 52.15849328577449],
                [-106.598460755792516, 52.158511681735128],
                [-106.598425148928726, 52.158524057596445],
                [-106.598386258660156, 52.158533595787027],
                [-106.598329134733973, 52.158543234823647],
                [-106.598267294741348, 52.158550318624592],
                [-106.59821383757469, 52.158553760523795],
                [-106.598163078096491, 52.15855478391881],
                [-106.598162788668787, 52.158684710237935],
                [-106.598188770428607, 52.158685007252203],
                [-106.598277108364698, 52.158689389124902],
                [-106.598326104495072, 52.158694636586034],
                [-106.59837926419668, 52.158702749033303],
                [-106.598458145663685, 52.158719745376558],
                [-106.598500381957209, 52.158732908974223],
                [-106.598538996098213, 52.158749863579075],
                [-106.598563724851601, 52.158764013132135],
                [-106.598576493936847, 52.15877265762407],
                [-106.59855236158586, 52.158786481887546],
                [-106.598533930954858, 52.158801810922014],
                [-106.598522658260322, 52.158816476247942],
                [-106.598522939227323, 52.158842456804216],
                [-106.598539976780458, 52.158894496663422],
                [-106.598544859722324, 52.15891549121627],
                [-106.598541832141493, 52.159096206501133],
                [-106.598540586449147, 52.159263067629716],
                [-106.598538119429392, 52.159434796524565],
                [-106.598537247871079, 52.159490274749409],
                [-106.598537713726529, 52.15965555847464],
                [-106.598545121206712, 52.15983320850718],
                [-106.598558397094834, 52.159993618811782],
                [-106.598574065161856, 52.160150210288968],
                [-106.598580398259656, 52.160263859202892],
                [-106.59857981729462, 52.160361423622781],
                [-106.59857433828185, 52.160420152515741],
                [-106.598565616659172, 52.160515456538604],
                [-106.598554864576585, 52.160619360666445],
                [-106.59854638754463, 52.160742931321515],
                [-106.598545272378786, 52.160917929775046],
                [-106.59855555039141, 52.16113887729572],
                [-106.598565133136276, 52.161318611605338],
                [-106.598571434263462, 52.161517949220965],
                [-106.598569932279602, 52.161641366593273],
                [-106.598566432073582, 52.161754243736745],
                [-106.598557079410938, 52.16192262881124],
                [-106.598561298523961, 52.162087150700614],
                [-106.598568815083013, 52.162242874990881],
                [-106.598577800871141, 52.162365447791245],
                [-106.598578795627958, 52.1624395903522],
                [-106.598570068837276, 52.162546406880757],
                [-106.598561735663253, 52.162624691876864],
                [-106.598545801385484, 52.162762681791492],
                [-106.598539898088674, 52.162852560715265],
                [-106.598534557280189, 52.162950051732174],
                [-106.598527419435911, 52.163066030522998],
                [-106.598521651646635, 52.163187544170079],
                [-106.598523369942939, 52.163288169725611],
                [-106.598526128566661, 52.163351840927412],
                [-106.598536741189477, 52.16343339193044],
                [-106.598530168571941, 52.163443663790218],
                [-106.598522943533254, 52.163453487702142],
                [-106.59851509650251, 52.16346282229096],
                [-106.598506660528059, 52.163471628240579],
                [-106.598497671138404, 52.163479868465444],
                [-106.598488166200312, 52.16348750826333],
                [-106.598478185733896, 52.163494515456122],
                [-106.598473553564219, 52.163497583444162],
                [-106.598468818533874, 52.163500490162754],
                [-106.598463986250849, 52.16350323216647],
                [-106.598459062446622, 52.163505806203823],
                [-106.598454052952874, 52.163508209224368],
                [-106.598448963705124, 52.163510438378701],
                [-106.598443800744377, 52.16351249102869],
                [-106.598460895131836, 52.163528284268367],
                [-106.598460871090936, 52.163528263769706],
                [-106.59848633022736, 52.163549966928109],
                [-106.598420212021097, 52.163573827156057],
                [-106.598360713643018, 52.163589751408239],
                [-106.598343717025642, 52.163593487860595],
                [-106.598343753270186, 52.163595741286429],
                [-106.598202851642654, 52.163595682163979],
                [-106.5982053863342, 52.16366205869295],
                [-106.598205249427807, 52.163729441101928],
                [-106.598208119363576, 52.163730539249492],
                [-106.598289663352503, 52.163733454035203],
                [-106.598375987649405, 52.163744436711589],
                [-106.598445125561341, 52.163760399775697],
                [-106.598502691474735, 52.163780440514351],
                [-106.598460930745802, 52.163825805032687],
                [-106.598460906494083, 52.16383730911371],
                [-106.598467721209829, 52.16384064195806],
                [-106.59847447026614, 52.163844105833974],
                [-106.598481151147993, 52.163847699452155],
                [-106.598487761351848, 52.163851421466454],
                [-106.598494298414792, 52.16385527048898],
                [-106.598500759899991, 52.163859245084652],
                [-106.598507143394045, 52.163863343769258],
                [-106.59851566596555, 52.163869252116129],
                [-106.598523821579832, 52.163875657483949],
                [-106.59853158129043, 52.163882537139209],
                [-106.598538917562095, 52.163889866662423],
                [-106.598545804350536, 52.163897620042043],
                [-106.5985522172152, 52.16390576975995],
                [-106.598558133397802, 52.163914286892755],
                [-106.598567512820665, 52.16392985821853],
                [-106.598575899476529, 52.163945985951635],
                [-106.598583260492873, 52.163962606880879],
                [-106.598589567012809, 52.163979655855648],
                [-106.598594794322693, 52.163997066054428],
                [-106.598598921929792, 52.164014769234193],
                [-106.598601933660504, 52.164032696008711],
                [-106.598603817710028, 52.164050776112113],
                [-106.598604566686404, 52.16406893867758],
                [-106.598603573573058, 52.164970349040608],
                [-106.598624675795307, 52.165682084738059],
                [-106.598622572451589, 52.167523604127034],
                [-106.598622202426611, 52.16754833348633],
                [-106.598621168597148, 52.167573043999255],
                [-106.59861947170792, 52.167597717845631],
                [-106.598617112980705, 52.167622337241475],
                [-106.598614094114438, 52.167646884431633],
                [-106.598610417292491, 52.167671341724336],
                [-106.598606085163908, 52.167695691484447],
                [-106.598588735871246, 52.167786464977425],
                [-106.598584036136486, 52.167812880775529],
                [-106.59858004731592, 52.167839413227732],
                [-106.598576772277724, 52.167866043211681],
                [-106.598574213385277, 52.167892751524043],
                [-106.598572372483034, 52.167919518907176],
                [-106.598571250900164, 52.167946326069142],
                [-106.598570849444229, 52.167973153678965],
                [-106.598570355257863, 52.168406188437942],
                [-106.598570192654321, 52.16840922574373],
                [-106.59856983398717, 52.168412246178391],
                [-106.598569280766228, 52.1684152370999],
                [-106.598568535297076, 52.168418185989132],
                [-106.59856760070474, 52.168421080502426],
                [-106.598566480908218, 52.168423908526151],
                [-106.598565180583321, 52.168426658219829],
                [-106.59848711950076, 52.168474336857045],
                [-106.598484205084773, 52.16847484967716],
                [-106.59848128274723, 52.168475315259457],
                [-106.598478353258528, 52.168475733486041],
                [-106.598475417384165, 52.168476104245194],
                [-106.598472475895392, 52.16847642744051],
                [-106.598469529561939, 52.168476702989075],
                [-106.598466579150497, 52.168476930813675],
                [-106.598458296077609, 52.168542527407475],
                [-106.598456367345946, 52.168760107693565],
                [-106.598445708879652, 52.168837607641152],
                [-106.598422080144658, 52.168823024231415],
                [-106.598185063877906, 52.168799171477716],
                [-106.597809699747174, 52.168797946997856],
                [-106.597805619886458, 52.171997469813697],
                [-106.598624615877895, 52.171997861559852],
                [-106.598623476805656, 52.172943015735839],
                [-106.598338161654993, 52.17294198036204],
                [-106.598337648927966, 52.173552645579413],
                [-106.598311514264651, 52.173791055326568],
                [-106.598269395450274, 52.174027165966514],
                [-106.598211483440522, 52.174259907083972],
                [-106.598138040768376, 52.174488223536166],
                [-106.598049400396107, 52.174711080244371],
                [-106.597945964174855, 52.174927466880028],
                [-106.59782820103645, 52.175136402449418],
                [-106.597696644865195, 52.175336939731999],
                [-106.597551892074975, 52.17552816958959],
                [-106.597394598906234, 52.175709225071834],
                [-106.597225478457389, 52.175879285361582],
                [-106.597045297436111, 52.176037579480173],
                [-106.596854872696071, 52.176183389797266],
                [-106.596655067549591, 52.176316055279152],
                [-106.596446787804155, 52.1764349744806],
                [-106.590373259924064, 52.180316049255005],
                [-106.590565093666584, 52.180316652860022],
                [-106.588745754734887, 52.18147905253452],
                [-106.588579650078628, 52.181463785590338],
                [-106.588276324712552, 52.18165099194573],
                [-106.588301112541146, 52.181763126912536],
                [-106.586974464666383, 52.18261066852434],
                [-106.586974516905997, 52.182545446074876],
                [-106.586547227612499, 52.182818487162621],
                [-106.586242027767099, 52.182899625263623],
                [-106.585861722227421, 52.18316070563548],
                [-106.585806333457214, 52.183291912598548],
                [-106.584837141240257, 52.183911196610424],
                [-106.584746227282253, 52.183910930627718],
                [-106.584382570264651, 52.184143227250267],
                [-106.584125702534166, 52.184311381875723],
                [-106.583878697413297, 52.184493715311831],
                [-106.583642336656325, 52.184689650503053],
                [-106.583417368292416, 52.184898567342309],
                [-106.583204504317678, 52.185119804634226],
                [-106.5830044184287, 52.185352662199712],
                [-106.582817743856324, 52.185596403072907],
                [-106.58267684133672, 52.185795970071403],
                [-106.582725699633485, 52.185862598796142],
                [-106.58265613483745, 52.185984981178436],
                [-106.582591693763817, 52.1861101373024],
                [-106.58253248679101, 52.186237852776678],
                [-106.582478615346176, 52.186367908823733],
                [-106.582430171706648, 52.186500082655563],
                [-106.582387238861699, 52.186634147859323],
                [-106.582349890358003, 52.186769874780474],
                [-106.582164689672084, 52.187516652725535],
                [-106.582120335718571, 52.187516532857138],
                [-106.581572228851869, 52.189726492759846],
                [-106.577792964652687, 52.189587317402022],
                [-106.577786925776138, 52.189649233002925],
                [-106.575299014219212, 52.189557546470382],
                [-106.57528695119862, 52.18952399612003],
                [-106.575270615227495, 52.189471205132435],
                [-106.57525686324621, 52.189409316601065],
                [-106.575250850082909, 52.189370933017209],
                [-106.575246856310287, 52.189335729891994],
                [-106.575244764483372, 52.18926894322135],
                [-106.575244745095674, 52.189250257981541],
                [-106.574953672377475, 52.189239527455186],
                [-106.57495352048258, 52.189288509776354],
                [-106.574950330941448, 52.189340324317364],
                [-106.574943657005491, 52.189391623461098],
                [-106.574933228105323, 52.189445782572001],
                [-106.574918237968021, 52.189499875579337],
                [-106.574900420601537, 52.189551051313742],
                [-106.574891463923208, 52.189568384005973],
                [-106.574887815723415, 52.18957480751849],
                [-106.572460943680014, 52.189485311059947],
                [-106.572364553022751, 52.189417461371356],
                [-106.571989922769006, 52.189405092525007],
                [-106.571873070483392, 52.189463624319735],
                [-106.569512500551255, 52.189376512747714],
                [-106.569497699609059, 52.189353452414224],
                [-106.569092493598632, 52.189338494342117],
                [-106.56908045983127, 52.189360564095558],
                [-106.56648036579189, 52.189264548719663],
                [-106.566426507658136, 52.189191226588548],
                [-106.5659245967408, 52.189169839836005],
                [-106.565865348838884, 52.189241832395439],
                [-106.563161736438033, 52.189141915600388],
                [-106.563161750201203, 52.189074373703285],
                [-106.561575956664399, 52.189015740626303],
                [-106.561466530272838, 52.18901126188053],
                [-106.561357143399832, 52.189005904049729],
                [-106.561247803107094, 52.188999667483579],
                [-106.561138516452033, 52.188992552581105],
                [-106.561029290492328, 52.188984559800694],
                [-106.560920132282291, 52.18897568966009],
                [-106.560811048863783, 52.188965942735067],
                [-106.560499204600376, 52.189127442353822],
                [-106.559916926053631, 52.189112628467491],
                [-106.559337230226134, 52.189055878966343],
                [-106.558763133372835, 52.188957489132001],
                [-106.558197622613065, 52.1888179708967],
                [-106.557643640393493, 52.188638050201909],
                [-106.557104069172041, 52.188418663201439],
                [-106.556581716431523, 52.188160951403908],
                [-106.556079300054975, 52.18786625572465],
                [-106.555599434197262, 52.187536109516174],
                [-106.555144615682877, 52.187172230581645],
                [-106.554717211011578, 52.186776512244506],
                [-106.555193002292924, 52.186628223349672],
                [-106.554646516893413, 52.185965796880282],
                [-106.554136318364925, 52.185347335386808],
                [-106.553826915897034, 52.18497226884125],
                [-106.553488075285671, 52.184561508185404],
                [-106.553052469069826, 52.183638053992816],
                [-106.552655356395078, 52.18397406100712],
                [-106.552640914950231, 52.183942840906333],
                [-106.552605363289715, 52.183864522412691],
                [-106.55257653784642, 52.183799002816293],
                [-106.552553973634872, 52.183747539012707],
                [-106.55253561820652, 52.183701301945852],
                [-106.552509708926536, 52.183636379641918],
                [-106.552478930627842, 52.183521504979581],
                [-106.552452133407215, 52.183378732275195],
                [-106.552414489748102, 52.183240916170227],
                [-106.552408673325445, 52.183223287501917],
                [-106.552391052584284, 52.183168766283792],
                [-106.552378253619395, 52.183128044316504],
                [-106.552363865957943, 52.18308104716774],
                [-106.552314992095489, 52.182876652683802],
                [-106.552265377270615, 52.182878251767875],
                [-106.552184382638629, 52.182884041471333],
                [-106.552108044514654, 52.182889096036881],
                [-106.551969549347803, 52.182899206765121],
                [-106.551795767356978, 52.182911893347871],
                [-106.551690060804759, 52.182919917047514],
                [-106.551701373834206, 52.182982040405022],
                [-106.551728677888192, 52.18312506514949],
                [-106.551736214892244, 52.18316462245501],
                [-106.551742146092607, 52.183183430686995],
                [-106.551748707903812, 52.183197105660931],
                [-106.55175731444821, 52.183210773203392],
                [-106.551763696131786, 52.183219020709146],
                [-106.551767961002724, 52.183224192979495],
                [-106.551803718586086, 52.183400325621079],
                [-106.55184914391144, 52.183574215966452],
                [-106.551904098476356, 52.183745333788458],
                [-106.551968414700227, 52.183913157312411],
                [-106.552041896474165, 52.184077174812934],
                [-106.552124319746724, 52.184236886167383],
                [-106.552215433181175, 52.184391804386614]
              ]
            ]
          ]
        }
      },
      {
        type: "Feature",
        properties: {
          fid: 2,
          handle: 89,
          block: -1,
          etype: 25,
          space: 0,
          layer: "GPLD3LOT$LAND_LINES",
          olinetype: "BYLAYER",
          linetype: "",
          color: "255,0,0,254",
          ocolor: 256,
          color24: -1,
          transparency: 0,
          lweight: -1,
          linewidth: 0.5,
          ltscale: 5.0,
          visible: 1,
          width: 0.0,
          thickness: 0.0,
          ext: "(3:0,0,1)"
        },
        geometry: {
          type: "MultiPolygon",
          coordinates: [
            [
              [
                [-106.622532036450167, 52.197667988553079],
                [-106.622531325042843, 52.197643866548205],
                [-106.622531427356861, 52.197608735752439],
                [-106.622531500594121, 52.19758358782812],
                [-106.622531587109535, 52.197559288559297],
                [-106.622496519799583, 52.197537249679428],
                [-106.622493954568654, 52.197535257831852],
                [-106.62249214843547, 52.197532900234428],
                [-106.622491202910524, 52.197529576806851],
                [-106.62249129216184, 52.197528188560995],
                [-106.622491904015007, 52.197526233934504],
                [-106.622493350992485, 52.197524036002555],
                [-106.622495457315296, 52.197522116669369],
                [-106.622497491542674, 52.197520842922827],
                [-106.622501191828775, 52.197519310630611],
                [-106.622504810461848, 52.197518462018735],
                [-106.622509559957109, 52.197518088873579],
                [-106.622531691286426, 52.197518113213455],
                [-106.622531736404454, 52.197502620108708],
                [-106.622532300266613, 52.197314421545897],
                [-106.622532339825611, 52.197295569049416],
                [-106.62244231058969, 52.19729534095967],
                [-106.622437314726682, 52.197295064551049],
                [-106.622433327029896, 52.197293749016183],
                [-106.622431459335914, 52.197292503089422],
                [-106.622430040454461, 52.197290816635658],
                [-106.6224295155899, 52.197287741056087],
                [-106.622430801719176, 52.197285327246803],
                [-106.622432488681611, 52.19728392251357],
                [-106.622435112694546, 52.197282324730011],
                [-106.622532555585309, 52.197222824311275],
                [-106.622532674966379, 52.19718257286965],
                [-106.622532878167775, 52.197114062351787],
                [-106.622533853993133, 52.197043136731807],
                [-106.622519080907011, 52.197083480794241],
                [-106.62250822120923, 52.19710973933374],
                [-106.622505910747904, 52.197113472364009],
                [-106.622387234420529, 52.197088625214903],
                [-106.622354064046363, 52.197121324525419],
                [-106.622047633982262, 52.197149369797387],
                [-106.621827638933041, 52.197202621464356],
                [-106.620581504758732, 52.197199454364878],
                [-106.620581323684405, 52.197226302825584],
                [-106.619460524683035, 52.197223479976024],
                [-106.619461983081123, 52.19674120337379],
                [-106.617707110463655, 52.196736702802696],
                [-106.617652501560897, 52.196736562331978],
                [-106.617710856016402, 52.196805532934725],
                [-106.617793931661623, 52.196895217338955],
                [-106.617982083580145, 52.197128368387276],
                [-106.618039173953491, 52.197226932979312],
                [-106.618099786387617, 52.197313688296198],
                [-106.618153733899263, 52.197420783956716],
                [-106.61818259630212, 52.19755069353792],
                [-106.61818434510171, 52.19763710526626],
                [-106.618209528740039, 52.197825654197409],
                [-106.618241102805072, 52.197991528705487],
                [-106.618255373926971, 52.198085856312879],
                [-106.618272121767305, 52.198167894956185],
                [-106.618291541722684, 52.198245297525517],
                [-106.618310110414015, 52.198325849816733],
                [-106.618324610166709, 52.198407177242956],
                [-106.618347373815311, 52.198552534556882],
                [-106.619309865721803, 52.198088557767285],
                [-106.619457889261994, 52.198089600069466],
                [-106.619459364018482, 52.19760732357831],
                [-106.621929763758359, 52.19761361449158],
                [-106.622293820308471, 52.197646629851754],
                [-106.622322335809201, 52.197649214578689],
                [-106.622426204221824, 52.19769436228156],
                [-106.622502509375451, 52.197641232787944],
                [-106.622525124368551, 52.197660392613244],
                [-106.622532036450167, 52.197667988553079]
              ]
            ]
          ]
        }
      }
    ]
  },
  consLimit: {
    type: "FeatureCollection",
    name: "cons_limit",
    crs: {
      type: "name",
      properties: {
        name: "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    features: [
      {
        type: "Feature",
        properties: {
          fid: 1,
          handle: 1068,
          block: -1,
          etype: 25,
          space: 0,
          layer: "GPLD3LOT$LAND_LINE_CONS_LIMIT",
          olinetype: "BYLAYER",
          linetype: "",
          color: "0,255,255,254",
          ocolor: 256,
          color24: -1,
          transparency: 0,
          lweight: -1,
          linewidth: 0.25,
          ltscale: 1.0,
          visible: 1,
          width: 0.0,
          thickness: 0.0,
          ext: "(3:0,0,1)"
        },
        geometry: {
          type: "LineString",
          coordinates: [
            [-106.615513633257478, 52.198371604253644, 0.0],
            [-106.607528153447717, 52.198350649607654, 0.0],
            [-106.607497462062355, 52.198350567815048, 0.0],
            [-106.607466682050415, 52.198350484497574, 0.0],
            [-106.607435795673226, 52.19835039833233, 0.0],
            [-106.607404802970862, 52.198350307996947, 0.0],
            [-106.60737370394051, 52.19835021219658, 0.0],
            [-106.607342498592359, 52.19835010959126, 0.0],
            [-106.607311186951591, 52.198349998849849, 0.0],
            [-106.6072797690274, 52.198349878605406, 0.0],
            [-106.607248244843987, 52.198349747499776, 0.0],
            [-106.607216614439196, 52.198349604147701, 0.0],
            [-106.607184877836232, 52.198349447164041, 0.0],
            [-106.607153035056712, 52.198349275118801, 0.0],
            [-106.60712108613815, 52.198349086617668, 0.0],
            [-106.607089031159688, 52.198348880202879, 0.0],
            [-106.607056072428904, 52.198348648838177, 0.0],
            [-106.607023752259522, 52.198348401366083, 0.0],
            [-106.606991326191022, 52.198348131509036, 0.0],
            [-106.606958794301221, 52.198347837773291, 0.0],
            [-106.606926156652747, 52.198347518647353, 0.0],
            [-106.606894813489689, 52.198347187419735, 0.0],
            [-106.606895424138699, 52.197965083573465, 0.0],
            [-106.606872538414223, 52.197964822678003, 0.0],
            [-106.606840488326384, 52.197964429322475, 0.0],
            [-106.606808374933351, 52.197964005799655, 0.0],
            [-106.606776198358546, 52.19796355066017, 0.0],
            [-106.606743958739642, 52.197963062445488, 0.0],
            [-106.606711656199366, 52.197962539688248, 0.0],
            [-106.60667929091835, 52.197961980902349, 0.0],
            [-106.606646863077174, 52.197961384601633, 0.0],
            [-106.606614372841818, 52.19796074930025, 0.0],
            [-106.606581820421852, 52.197960073502657, 0.0],
            [-106.606549717269672, 52.197959366941383, 0.0],
            [-106.60544646216492, 52.197914716175823, 0.0],
            [-106.604346588595988, 52.197817537761672, 0.0],
            [-106.603252596054503, 52.197668052542205, 0.0],
            [-106.602166970671519, 52.197466600222462, 0.0],
            [-106.601092179553277, 52.197213638609334, 0.0],
            [-106.600030665207825, 52.196909742569282, 0.0],
            [-106.598984839946752, 52.196555602710696, 0.0],
            [-106.598984200892829, 52.197530024428893, 0.0],
            [-106.598616833273311, 52.197529932917924, 0.0],
            [-106.598617098461375, 52.197036085145285, 0.0],
            [-106.598082379495438, 52.196296281192843, 0.0],
            [-106.595465556451174, 52.194798457477326, 0.0],
            [-106.595454762793324, 52.194798421524027, 0.0],
            [-106.592618085388835, 52.193174575264393, 0.0],
            [-106.592595676482446, 52.193161746895086, 0.0],
            [-106.59257330541206, 52.193148941910245, 0.0],
            [-106.592550978633867, 52.193136165743567, 0.0],
            [-106.592528694775396, 52.193123419294729, 0.0],
            [-106.592506452435529, 52.193110703481857, 0.0],
            [-106.59248425024208, 52.193098019213664, 0.0],
            [-106.592462086852152, 52.193085367398425, 0.0],
            [-106.592439960893216, 52.193072748935883, 0.0],
            [-106.592417871050642, 52.193060164706971, 0.0],
            [-106.592395815980865, 52.19304761560204, 0.0],
            [-106.5923737943845, 52.193035102519794, 0.0],
            [-106.592351804946261, 52.193022626323256, 0.0],
            [-106.592329846366454, 52.193010187902125, 0.0],
            [-106.592307916358024, 52.192997787539049, 0.0],
            [-106.592285986437517, 52.192985410989301, 0.0],
            [-106.592264109178984, 52.192973089103518, 0.0],
            [-106.592242258946982, 52.192960809136082, 0.0],
            [-106.592220433274491, 52.192948571246177, 0.0],
            [-106.59219863093432, 52.192936376304587, 0.0],
            [-106.592176850756431, 52.192924225145319, 0.0],
            [-106.592155091527587, 52.192912118620995, 0.0],
            [-106.592133352078733, 52.192900057592581, 0.0],
            [-106.592111631268807, 52.192888042884761, 0.0],
            [-106.592089927943022, 52.192876075349318, 0.0],
            [-106.592068240990216, 52.192864155828474, 0.0],
            [-106.592046569283895, 52.192852285146678, 0.0],
            [-106.592024911742129, 52.192840464145782, 0.0],
            [-106.592003267282621, 52.192828693658583, 0.0],
            [-106.591981634837751, 52.192816974517775, 0.0],
            [-106.591960013368791, 52.192805307546571, 0.0],
            [-106.591938241541982, 52.192793607182821, 0.0],
            [-106.590897422392487, 52.192302507625897, 0.0],
            [-106.589828554024237, 52.191875888723217, 0.0],
            [-106.588735626701222, 52.191515343110943, 0.0],
            [-106.587622720493513, 52.191222216764793, 0.0],
            [-106.586493990067495, 52.190997603974239, 0.0],
            [-106.585353649158975, 52.19084234325706, 0.0],
            [-106.58420595484678, 52.190757014224573, 0.0],
            [-106.584176873367056, 52.190755378812582, 0.0],
            [-106.584148215981273, 52.19075380326462, 0.0],
            [-106.584119489566348, 52.190752258821185, 0.0],
            [-106.58409069436334, 52.190750744444948, 0.0],
            [-106.584061830627306, 52.190749259080405, 0.0],
            [-106.584032898598949, 52.19074780168129, 0.0],
            [-106.584003898503411, 52.190746371174505, 0.0],
            [-106.583974830566532, 52.190744966504994, 0.0],
            [-106.583945694983512, 52.190743586582087, 0.0],
            [-106.583916491979238, 52.19074223032375, 0.0],
            [-106.583887221748341, 52.190740896621342, 0.0],
            [-106.58385788445716, 52.190739584393626, 0.0],
            [-106.583828480314011, 52.190738292504804, 0.0],
            [-106.583799009498577, 52.190737019837471, 0.0],
            [-106.583769472161023, 52.190735765265615, 0.0],
            [-106.583739868465784, 52.190734527654051, 0.0],
            [-106.58370974946105, 52.190733287359002, 0.0],
            [-106.583680048934184, 52.190732081909239, 0.0],
            [-106.583650278729451, 52.190730889741729, 0.0],
            [-106.583620442849295, 52.190729709858566, 0.0],
            [-106.583590541397442, 52.190728541062448, 0.0],
            [-106.583560574537074, 52.190727382182232, 0.0],
            [-106.583530542386583, 52.190726232020396, 0.0],
            [-106.583500445079238, 52.190725089388231, 0.0],
            [-106.583470282747086, 52.190723953061067, 0.0],
            [-106.583440055523113, 52.190722821841213, 0.0],
            [-106.583409763524102, 52.190721694486207, 0.0],
            [-106.583379406867465, 52.190720569771564, 0.0],
            [-106.583348985699587, 52.190719446463454, 0.0],
            [-106.583318500121948, 52.190718323301645, 0.0],
            [-106.583287950280265, 52.190717199034296, 0.0],
            [-106.563161566831525, 52.189974932237433, 0.0],
            [-106.563161548513776, 52.190064988080834, 0.0],
            [-106.560754149292521, 52.189975970951124, 0.0],
            [-106.560740969689974, 52.19011056858777, 0.0],
            [-106.560474977133978, 52.190100730094116, 0.0],
            [-106.559934931816315, 52.190071944851759, 0.0],
            [-106.559396566599133, 52.190020559745768, 0.0],
            [-106.5588608268299, 52.189946665002928, 0.0],
            [-106.558328653234625, 52.189850390381245, 0.0],
            [-106.557800980290011, 52.189731904930319, 0.0],
            [-106.557278734568172, 52.189591416709398, 0.0],
            [-106.556762833101175, 52.189429172408055, 0.0],
            [-106.556547221027643, 52.189612848297102, 0.0],
            [-106.556325378285308, 52.189788948259796, 0.0],
            [-106.556097570934057, 52.189957261094598, 0.0],
            [-106.555864072190147, 52.190117584939792, 0.0],
            [-106.555625162090635, 52.190269727515464, 0.0],
            [-106.555381127165958, 52.190413506354517, 0.0],
            [-106.555132260091952, 52.190548749021133, 0.0],
            [-106.554731458978026, 52.190274484060581, 0.0],
            [-106.554962980627351, 52.190149020060893, 0.0],
            [-106.555190070902796, 52.19001570278035, 0.0],
            [-106.555412463520028, 52.189874688549018, 0.0],
            [-106.555629897706226, 52.189726142714782, 0.0],
            [-106.555842118497281, 52.189570239458611, 0.0],
            [-106.556048877050671, 52.189407161594467, 0.0],
            [-106.556249930925375, 52.189237100342702, 0.0],
            [-106.55608551181902, 52.189169173549395, 0.0],
            [-106.555922414357724, 52.189098131943844, 0.0],
            [-106.555760697545324, 52.189024001221689, 0.0],
            [-106.555600419880633, 52.188946808202665, 0.0],
            [-106.555441639349397, 52.188866580810078, 0.0],
            [-106.555284413387909, 52.188783348067169, 0.0],
            [-106.555128798875131, 52.188697140086894, 0.0],
            [-106.555277910390174, 52.188598230429264, 0.0],
            [-106.554992431912495, 52.188431469267677, 0.0],
            [-106.554715940551958, 52.188250196618313, 0.0],
            [-106.554449173283487, 52.18805489564874, 0.0],
            [-106.55419284115122, 52.187846086922939, 0.0],
            [-106.553947627393043, 52.187624327006191, 0.0],
            [-106.553714185617963, 52.187390206988063, 0.0],
            [-106.553493138043379, 52.187144350898507, 0.0],
            [-106.551796679873661, 52.185087807428381, 0.0],
            [-106.551731551215838, 52.18500736225073, 0.0],
            [-106.551668296972267, 52.184925435033605, 0.0],
            [-106.551606950855771, 52.184842069442304, 0.0],
            [-106.55154754556132, 52.184757309905756, 0.0],
            [-106.551490112742968, 52.184671201600381, 0.0],
            [-106.551434683021128, 52.184583790419168, 0.0],
            [-106.55138128593903, 52.184495122952271, 0.0]
          ]
        }
      },
      {
        type: "Feature",
        properties: {
          fid: 2,
          handle: 1069,
          block: -1,
          etype: 25,
          space: 0,
          layer: "GPLD3LOT$LAND_LINE_CONS_LIMIT",
          olinetype: "BYLAYER",
          linetype: "",
          color: "0,255,255,254",
          ocolor: 256,
          color24: -1,
          transparency: 0,
          lweight: -1,
          linewidth: 0.25,
          ltscale: 1.0,
          visible: 1,
          width: 0.0,
          thickness: 0.0,
          ext: "(3:0,0,1)"
        },
        geometry: {
          type: "LineString",
          coordinates: [
            [-106.598691574498432, 52.195009962113893, 0.0],
            [-106.598611018620474, 52.194970909906907, 0.0],
            [-106.598530707536355, 52.194931356735644, 0.0],
            [-106.598450644360113, 52.194891304137847, 0.0],
            [-106.598370832187342, 52.194850753661733, 0.0],
            [-106.598291274121237, 52.194809706882545, 0.0],
            [-106.598211973247132, 52.194768165393462, 0.0],
            [-106.598132932642201, 52.194726130807211, 0.0],
            [-106.598110945577602, 52.194714317571702, 0.0],
            [-106.598089321596333, 52.194702651748202, 0.0],
            [-106.598067686654161, 52.194690933747552, 0.0],
            [-106.598046039698005, 52.194679164393236, 0.0],
            [-106.59802437968969, 52.194667344517576, 0.0],
            [-106.598002705532551, 52.194655474953642, 0.0],
            [-106.597981016144914, 52.194643556543284, 0.0],
            [-106.597959310400498, 52.19463159011098, 0.0],
            [-106.597937587188383, 52.194619576499015, 0.0],
            [-106.597915845368661, 52.194607516559017, 0.0],
            [-106.597894083771223, 52.194595411116062, 0.0],
            [-106.59787230122727, 52.194583261031163, 0.0],
            [-106.597850496553022, 52.194571067156581, 0.0],
            [-106.597828668564091, 52.194558830326535, 0.0],
            [-106.597806816033483, 52.194546551411868, 0.0],
            [-106.597784937733536, 52.194534231265379, 0.0],
            [-106.597762700836171, 52.194521683648453, 0.0],
            [-106.597740791213795, 52.19450929681431, 0.0],
            [-106.597718852010445, 52.194496871389504, 0.0],
            [-106.597696881954931, 52.19448440823642, 0.0],
            [-106.597674879747473, 52.194471908235847, 0.0],
            [-106.597652844073323, 52.194459372259757, 0.0],
            [-106.59763077364731, 52.194446801188725, 0.0],
            [-106.59760866714106, 52.194434195921914, 0.0],
            [-106.597586523225175, 52.194421557331452, 0.0],
            [-106.597564340527413, 52.19440888631712, 0.0],
            [-106.597542117719684, 52.194396183786992, 0.0],
            [-106.597519853429716, 52.194383450640863, 0.0],
            [-106.597497546271299, 52.194370687796571, 0.0],
            [-106.59747519487243, 52.194357896162849, 0.0],
            [-106.597452797817638, 52.194345076657996, 0.0],
            [-106.595919054775223, 52.193467153406608, 0.0],
            [-106.59774023079008, 52.192265795556544, 0.0],
            [-106.59816481120761, 52.192508828629052, 0.0],
            [-106.598692907620531, 52.193255093572475, 0.0],
            [-106.59869171133046, 52.194809161789209, 0.0],
            [-106.598691574498432, 52.195009962113893, 0.0]
          ]
        }
      },
      {
        type: "Feature",
        properties: {
          fid: 11,
          handle: 1087,
          block: -1,
          etype: 25,
          space: 0,
          layer: "GPLD3LOT$LAND_LINE_CONS_LIMIT",
          olinetype: "BYLAYER",
          linetype: "",
          color: "0,255,255,254",
          ocolor: 256,
          color24: -1,
          transparency: 0,
          lweight: -1,
          linewidth: 0.25,
          ltscale: 1.0,
          visible: 1,
          width: 0.0,
          thickness: 0.0,
          ext: "(3:0,0,1)"
        },
        geometry: {
          type: "LineString",
          coordinates: [
            [-106.613737595260602, 52.196434270872096, 0.0],
            [-106.607541758464293, 52.196417963203594, 0.0],
            [-106.607511103867452, 52.196417881495876, 0.0],
            [-106.607480537918448, 52.196417798752137, 0.0],
            [-106.607450078350865, 52.196417713741774, 0.0],
            [-106.607419725163822, 52.196417625224008, 0.0],
            [-106.607389478386025, 52.196417531966709, 0.0],
            [-106.607359338031884, 52.196417432746919, 0.0],
            [-106.607329304101853, 52.196417326359843, 0.0],
            [-106.607299376625278, 52.19641721159131, 0.0],
            [-106.607269555619169, 52.19641708729025, 0.0],
            [-106.607239841098959, 52.196416952260655, 0.0],
            [-106.607210233081958, 52.196416805360442, 0.0],
            [-106.607180731629413, 52.196416645446966, 0.0],
            [-106.607151336758989, 52.196416471387082, 0.0],
            [-106.607122048503626, 52.196416282065499, 0.0],
            [-106.607093664605955, 52.196416081999693, 0.0],
            [-106.607064642887394, 52.19641585977454, 0.0],
            [-106.607035727948073, 52.196415619129681, 0.0],
            [-106.607006919822894, 52.196415359003751, 0.0],
            [-106.606978218591294, 52.196415078352672, 0.0],
            [-106.606949624319071, 52.196414776159614, 0.0],
            [-106.606921137086644, 52.196414451407513, 0.0],
            [-106.606897903318426, 52.196414166246186, 0.0],
            [-106.606897292397917, 52.196796281267105, 0.0],
            [-106.606879879413, 52.196796067552313, 0.0],
            [-106.606850660336306, 52.196795682193411, 0.0],
            [-106.606821506569275, 52.196795269808355, 0.0],
            [-106.606792418218987, 52.19679482930777, 0.0],
            [-106.606763395422419, 52.19679435961983, 0.0],
            [-106.606734438301629, 52.196793859663948, 0.0],
            [-106.606705546994547, 52.19679332839528, 0.0],
            [-106.606676721667768, 52.196792764750619, 0.0],
            [-106.606647962459562, 52.196792167694078, 0.0],
            [-106.606618774371071, 52.19679152528235, 0.0],
            [-106.605497066150491, 52.196744890791578, 0.0],
            [-106.60437982076833, 52.196634587367008, 0.0],
            [-106.603270649167811, 52.196460971514163, 0.0],
            [-106.602173136219776, 52.196224604358569, 0.0],
            [-106.601090829109992, 52.195926249844852, 0.0],
            [-106.600027225864977, 52.195566872261097, 0.0],
            [-106.59898576408203, 52.195147633123177, 0.0],
            [-106.598985985747902, 52.19481011896395, 0.0],
            [-106.598988866076468, 52.190344774241133, 0.0],
            [-106.598695151777846, 52.190343580941253, 0.0],
            [-106.598694836773177, 52.190752255364359, 0.0],
            [-106.598529615569333, 52.191184022206798, 0.0],
            [-106.598383645905059, 52.191390308632585, 0.0],
            [-106.597867767142503, 52.191786027128892, 0.0],
            [-106.595597948777581, 52.193283343525188, 0.0],
            [-106.594578968632376, 52.192700035336358, 0.0],
            [-106.594678667523979, 52.192634257634786, 0.0],
            [-106.594013898834476, 52.192253702713323, 0.0],
            [-106.593991447730858, 52.192240850424191, 0.0],
            [-106.593968949981885, 52.192227973153209, 0.0],
            [-106.593946395107139, 52.192215066672091, 0.0],
            [-106.593923781677461, 52.192202131926237, 0.0],
            [-106.593901108249398, 52.192189169870211, 0.0],
            [-106.593878373379482, 52.192176181458613, 0.0],
            [-106.593855575595995, 52.192163167673414, 0.0],
            [-106.593832713426877, 52.192150129487516, 0.0],
            [-106.593809785414678, 52.192137067873716, 0.0],
            [-106.593786790045101, 52.192123983850479, 0.0],
            [-106.593763725860683, 52.192110878390537, 0.0],
            [-106.593740591347768, 52.19209775253038, 0.0],
            [-106.593717384991365, 52.192084607270473, 0.0],
            [-106.593694105278146, 52.192071443656289, 0.0],
            [-106.593670340824076, 52.192058031379474, 0.0],
            [-106.593646882130386, 52.192044819003144, 0.0],
            [-106.593623345439397, 52.192031591464101, 0.0],
            [-106.593599729223754, 52.192018349825943, 0.0],
            [-106.593576031927185, 52.192005095161711, 0.0],
            [-106.59355225200936, 52.191991828580079, 0.0],
            [-106.593528387914304, 52.191978551163032, 0.0],
            [-106.593504438102002, 52.191965264028291, 0.0],
            [-106.593480401003475, 52.191951968302945, 0.0],
            [-106.593456275064398, 52.191938665113916, 0.0],
            [-106.593432058716431, 52.191925355606251, 0.0],
            [-106.593407750406527, 52.191912040942789, 0.0],
            [-106.593383348567031, 52.191898722286602, 0.0],
            [-106.593358851645178, 52.191885400809497, 0.0],
            [-106.593334258059954, 52.191872077710663, 0.0],
            [-106.593309566259904, 52.191858754197881, 0.0],
            [-106.593285219972074, 52.191845670771876, 0.0],
            [-106.593221028490078, 52.191811437922361, 0.0],
            [-106.593156685534254, 52.191777490635104, 0.0],
            [-106.593092192379103, 52.191743829576801, 0.0],
            [-106.593027550290557, 52.191710455414061, 0.0],
            [-106.592962760549185, 52.19167736880172, 0.0],
            [-106.592897824435639, 52.191644570397393, 0.0],
            [-106.592832743228513, 52.191612060849451, 0.0],
            [-106.592832709447222, 52.191728001014333, 0.0],
            [-106.59276487087773, 52.191693966133677, 0.0],
            [-106.59269687958475, 52.191660237381257, 0.0],
            [-106.592628736951141, 52.191626815441843, 0.0],
            [-106.592560444361865, 52.191593700992591, 0.0],
            [-106.592492003202992, 52.191560894706527, 0.0],
            [-106.592423414865337, 52.191528397250728, 0.0],
            [-106.592354680741849, 52.191496209287109, 0.0],
            [-106.592354821350241, 52.191027618330658, 0.0],
            [-106.591975172302696, 52.190866628246255, 0.0],
            [-106.591592351654896, 52.190713332592175, 0.0],
            [-106.591206515327926, 52.190567793806615, 0.0],
            [-106.590817820484503, 52.190430071170333, 0.0],
            [-106.590426425438551, 52.190300220777324, 0.0],
            [-106.590032489604269, 52.190178295516631, 0.0],
            [-106.589636173444617, 52.190064345051098, 0.0],
            [-106.589968547974109, 52.18961410406073, 0.0],
            [-106.589622038726318, 52.18952052510457, 0.0],
            [-106.589274204805619, 52.189431996900574, 0.0],
            [-106.588925119831387, 52.189348538187907, 0.0],
            [-106.588574857676562, 52.189270166623821, 0.0],
            [-106.5882234924686, 52.189196898799317, 0.0],
            [-106.587871098585836, 52.18912875021914, 0.0],
            [-106.587517750598877, 52.189065735307167, 0.0],
            [-106.587332832171995, 52.189472662404185, 0.0],
            [-106.586923130754315, 52.18940600834339, 0.0],
            [-106.586512406100709, 52.189345981073529, 0.0],
            [-106.586100765387513, 52.189292596254738, 0.0],
            [-106.585688316034052, 52.189245867817583, 0.0],
            [-106.585275165669927, 52.189205807956569, 0.0],
            [-106.584861422105917, 52.189172427126501, 0.0],
            [-106.584447193311775, 52.189145734037687, 0.0],
            [-106.584414108783676, 52.189143873493016, 0.0],
            [-106.584380220237591, 52.189142010340142, 0.0],
            [-106.584346439135999, 52.189140194135895, 0.0],
            [-106.584312765857717, 52.189138423193839, 0.0],
            [-106.584279200739616, 52.189136695882098, 0.0],
            [-106.584245744117908, 52.189135010550771, 0.0],
            [-106.584212396329804, 52.189133365576993, 0.0],
            [-106.584179157640023, 52.189131759356762, 0.0],
            [-106.584146028371165, 52.189130190267392, 0.0],
            [-106.584113008789544, 52.18912865674988, 0.0],
            [-106.584080099145595, 52.18912715720942, 0.0],
            [-106.584047299706342, 52.18912569010498, 0.0],
            [-106.584014610694538, 52.189124253887123, 0.0],
            [-106.583982032362584, 52.189122847015014, 0.0],
            [-106.58394956492026, 52.189121467984315, 0.0],
            [-106.583917208562738, 52.189120115290955, 0.0],
            [-106.583885758101175, 52.189118820155009, 0.0],
            [-106.583853567828982, 52.189117512896281, 0.0],
            [-106.583821489218593, 52.189116227633463, 0.0],
            [-106.583789522452761, 52.18911496292553, 0.0],
            [-106.583757667699075, 52.189113717313695, 0.0],
            [-106.583725925126345, 52.189112489375148, 0.0],
            [-106.583694294874476, 52.189111277696398, 0.0],
            [-106.583662777113261, 52.189110080881605, 0.0],
            [-106.58363137199818, 52.189108897544038, 0.0],
            [-106.583600079641499, 52.189107726315605, 0.0],
            [-106.583568900199722, 52.18910656583656, 0.0],
            [-106.583537833829567, 52.189105414756163, 0.0],
            [-106.583506880630665, 52.189104271760385, 0.0],
            [-106.583476040731156, 52.189103135516895, 0.0],
            [-106.583445314290088, 52.189102004737805, 0.0],
            [-106.583208783722014, 52.189093301453617, 0.0],
            [-106.583752356777623, 52.18690126192832, 0.0],
            [-106.58383510148937, 52.186661694102142, 0.0],
            [-106.583934132207744, 52.186428386693407, 0.0],
            [-106.584048979642816, 52.18620244533485, 0.0],
            [-106.584179099529123, 52.185984940748305, 0.0],
            [-106.584323875242248, 52.185776903676008, 0.0],
            [-106.584482620695766, 52.185579319993842, 0.0],
            [-106.584654583606593, 52.185393126041156, 0.0],
            [-106.584838949045647, 52.185219204176967, 0.0],
            [-106.585034843321139, 52.185058378609867, 0.0],
            [-106.585241338102918, 52.184911411484492, 0.0],
            [-106.585457454818382, 52.18477899926522, 0.0],
            [-106.596756540402538, 52.177559618069409, 0.0],
            [-106.596756891173726, 52.177475012562091, 0.0],
            [-106.596758704686906, 52.177460985149473, 0.0],
            [-106.596761504940147, 52.177447120963642, 0.0],
            [-106.596765277932704, 52.177433489323441, 0.0],
            [-106.596770004798586, 52.17742015838666, 0.0],
            [-106.596775661902925, 52.177407194812979, 0.0],
            [-106.596782220956797, 52.177394663416628, 0.0],
            [-106.5967896491711, 52.177382626858154, 0.0],
            [-106.596797909402071, 52.177371145320642, 0.0],
            [-106.596806960344097, 52.177360276211395, 0.0],
            [-106.596816756747998, 52.177350073878181, 0.0],
            [-106.59682724962839, 52.177340589332736, 0.0],
            [-106.596838386518343, 52.177331869999755, 0.0],
            [-106.596850111730234, 52.17732395947214, 0.0],
            [-106.596862366648381, 52.1773168973072, 0.0],
            [-106.596875089983826, 52.17731071881596, 0.0],
            [-106.597674923947139, 52.176861284767575, 0.0],
            [-106.597706622492566, 52.176845957528968, 0.0],
            [-106.597739309645803, 52.176832870428328, 0.0],
            [-106.597772827321009, 52.176822086757959, 0.0],
            [-106.597807013422411, 52.176813658670646, 0.0],
            [-106.597841702614787, 52.176807626922667, 0.0],
            [-106.597876727134732, 52.176804020688252, 0.0],
            [-106.597911917601465, 52.176802857408603, 0.0],
            [-106.598127909311998, 52.176656154787636, 0.0],
            [-106.598334232380054, 52.176496139568435, 0.0],
            [-106.598530067531087, 52.17632344714729, 0.0],
            [-106.598714637133511, 52.176138763254123, 0.0],
            [-106.598887208292567, 52.175942821238998, 0.0],
            [-106.599047095758564, 52.175736399156442, 0.0],
            [-106.599193664645995, 52.175520316674003, 0.0],
            [-106.599326332951009, 52.175295431816259, 0.0],
            [-106.599444573872447, 52.175062637566946, 0.0],
            [-106.599547917896402, 52.174822858311011, 0.0],
            [-106.599635954655227, 52.174577046174811, 0.0],
            [-106.599708334575539, 52.174326177233517, 0.0],
            [-106.5997647702482, 52.174071247648563, 0.0],
            [-106.599805037572779, 52.17381326970208, 0.0],
            [-106.599828976657051, 52.173553267781585, 0.0],
            [-106.59982966161914, 52.172948058240095, 0.0],
            [-106.599281384330766, 52.172945638125299, 0.0],
            [-106.599284769799567, 52.169988538664136, 0.0],
            [-106.599274786214409, 52.168640144302216, 0.0],
            [-106.599278239428472, 52.165573029383438, 0.0],
            [-106.599278081035848, 52.165510987072473, 0.0],
            [-106.599277467106816, 52.165448947597724, 0.0],
            [-106.599276397690105, 52.165386914304683, 0.0],
            [-106.599274872824012, 52.165324890533149, 0.0],
            [-106.599272892599487, 52.165262879630063, 0.0],
            [-106.599270457127389, 52.165200884936773, 0.0],
            [-106.599267566535516, 52.165138909798394, 0.0],
            [-106.599264782022743, 52.165079213114154, 0.0],
            [-106.599262435571191, 52.165019497607311, 0.0],
            [-106.599260527305873, 52.16495976649275, 0.0],
            [-106.599259057333242, 52.164900022984504, 0.0],
            [-106.599258025733334, 52.164840270298548, 0.0],
            [-106.599257432556129, 52.164780511652793, 0.0],
            [-106.599257277837765, 52.164720750262255, 0.0],
            [-106.599262242477607, 52.160157670835062, 0.0],
            [-106.599222598859228, 52.158620389800994, 0.0],
            [-106.599222956262523, 52.158438436886456, 0.0],
            [-106.599072413141712, 52.158437299112983, 0.0],
            [-106.599078166337691, 52.155514208265387, 0.0],
            [-106.599261958082323, 52.155513387167652, 0.0],
            [-106.599280438686165, 52.155515947350004, 0.0],
            [-106.599299052056622, 52.155517223894243, 0.0],
            [-106.599317709147712, 52.15551721069459, 0.0],
            [-106.599336320694405, 52.155515907812507, 0.0],
            [-106.599354797654073, 52.155513321480605, 0.0],
            [-106.599373051631105, 52.155509464075287, 0.0],
            [-106.599390995288545, 52.155504354048382, 0.0],
            [-106.599408542777368, 52.155498015850746, 0.0],
            [-106.599425610151215, 52.155490479804932, 0.0],
            [-106.599442115748374, 52.155481781965129, 0.0],
            [-106.599457980606516, 52.155471963946177, 0.0],
            [-106.599473128819213, 52.155461072718019, 0.0],
            [-106.599487487914288, 52.155449160389246, 0.0],
            [-106.599500989192151, 52.155436283952433, 0.0],
            [-106.599513568060488, 52.155422505011295, 0.0],
            [-106.599525164339852, 52.155407889487826, 0.0],
            [-106.599535722547429, 52.155392507307617, 0.0],
            [-106.599545192169884, 52.155376432065161, 0.0],
            [-106.599553527899289, 52.155359740666576, 0.0],
            [-106.5995606898597, 52.155342512971337, 0.0],
            [-106.599566643784755, 52.155324831400179, 0.0],
            [-106.599571453640152, 52.152742589201871, 0.0],
            [-106.599683023748426, 52.152317617992864, 0.0],
            [-106.599703550077635, 52.152154298464652, 0.0],
            [-106.599187684048999, 52.1521297653169, 0.0],
            [-106.599187867833919, 52.152026008172513, 0.0],
            [-106.599189305733105, 52.151994676929874, 0.0],
            [-106.599193001105533, 52.151963531169692, 0.0],
            [-106.599198934673026, 52.151932733329879, 0.0],
            [-106.599207075494618, 52.151902444036743, 0.0],
            [-106.599217381104182, 52.151872821264057, 0.0],
            [-106.599229797757815, 52.151844019510875, 0.0],
            [-106.599244260699308, 52.151816188995539, 0.0],
            [-106.599249000216005, 52.15180939145565, 0.0],
            [-106.599254178602223, 52.151802921999575, 0.0],
            [-106.599259773225626, 52.151796808915599, 0.0],
            [-106.599265759610702, 52.15179107893163, 0.0],
            [-106.599272111594459, 52.15178575709978, 0.0],
            [-106.59927880139729, 52.151780866692199, 0.0],
            [-106.599285799773483, 52.151776429091107, 0.0],
            [-106.599293076120361, 52.151772463696027, 0.0],
            [-106.599300598622449, 52.151768987848214, 0.0],
            [-106.599308334391608, 52.151766016743828, 0.0],
            [-106.599316249599312, 52.151763563375837, 0.0],
            [-106.599334045949234, 52.151758376299107, 0.0],
            [-106.599351470652678, 52.15175205210025, 0.0],
            [-106.599368451137693, 52.151744617116485, 0.0],
            [-106.599384916677067, 52.151736102316129, 0.0],
            [-106.599400798691917, 52.151726543164834, 0.0],
            [-106.599416031032874, 52.151715979474822, 0.0],
            [-106.599430550260863, 52.151704455245628, 0.0],
            [-106.599444295898124, 52.151692018474925, 0.0],
            [-106.599457210693785, 52.151678720962074, 0.0],
            [-106.59946924086033, 52.151664618093484, 0.0],
            [-106.599480336287584, 52.151649768607143, 0.0],
            [-106.599490450767206, 52.151634234350489, 0.0],
            [-106.59949954216998, 52.151618080026793, 0.0],
            [-106.599575512750221, 52.151432102599905, 0.0],
            [-106.59956894789363, 52.151402563829038, 0.0],
            [-106.598886679374928, 52.151281729768876, 0.0],
            [-106.598525534660027, 52.151281533815485, 0.0],
            [-106.59852891958873, 52.151300866567148, 0.0],
            [-106.598536276631364, 52.151304968312694, 0.0],
            [-106.598543360074501, 52.1513095262954, 0.0],
            [-106.598550141668952, 52.151314522334353, 0.0],
            [-106.598556594359238, 52.151319936498105, 0.0],
            [-106.598562692408436, 52.151325747194271, 0.0],
            [-106.598568411493019, 52.151331931243469, 0.0],
            [-106.598573728799224, 52.151338463980203, 0.0],
            [-106.59857862312127, 52.151345319343811, 0.0],
            [-106.598583074928712, 52.151352469992226, 0.0],
            [-106.59858706647168, 52.151359887400837, 0.0],
            [-106.59859058182677, 52.151367541986311, 0.0],
            [-106.598602183775839, 52.151401913452972, 0.0],
            [-106.598612054408349, 52.151436821523937, 0.0],
            [-106.598620169093905, 52.151472179053592, 0.0],
            [-106.598626507562571, 52.151507897769982, 0.0],
            [-106.598631053992776, 52.15154388850079, 0.0],
            [-106.598633797040421, 52.151580061400708, 0.0],
            [-106.598634729851625, 52.151616326159278, 0.0],
            [-106.598632852305897, 52.152668968025289, 0.0],
            [-106.598632247708949, 52.152754875933759, 0.0],
            [-106.598630744414749, 52.152840772817399, 0.0],
            [-106.598628342591823, 52.152926649272551, 0.0],
            [-106.598625042493936, 52.153012495902651, 0.0],
            [-106.598620844481246, 52.153098303307161, 0.0],
            [-106.598615749023949, 52.15318406210158, 0.0],
            [-106.598609756675444, 52.153269762895476, 0.0],
            [-106.598602063835102, 52.153372143063343, 0.0],
            [-106.598595947556518, 52.153459596947272, 0.0],
            [-106.598590744073377, 52.153547109884123, 0.0],
            [-106.598586453950688, 52.153634672349646, 0.0],
            [-106.598583077655334, 52.1537222748102, 0.0],
            [-106.59858061555839, 52.153809907728821, 0.0],
            [-106.598579067920568, 52.153897561567049, 0.0],
            [-106.598578434919915, 52.153985226780975, 0.0],
            [-106.59857753761078, 52.154438287090791, 0.0],
            [-106.598577367429257, 52.15444759363205, 0.0],
            [-106.598576905760595, 52.15445689027456, 0.0],
            [-106.598576153060989, 52.154466167890853, 0.0],
            [-106.598575110063379, 52.154475417368296, 0.0],
            [-106.598573777790037, 52.154484629630133, 0.0],
            [-106.598572157556205, 52.154493795628206, 0.0],
            [-106.59857025095404, 52.15450290636678, 0.0],
            [-106.598534996591482, 52.154659872693408, 0.0],
            [-106.59853258633791, 52.15467139003843, 0.0],
            [-106.598530538101869, 52.154682977240547, 0.0],
            [-106.598528853897719, 52.154694622928211, 0.0],
            [-106.598527535377784, 52.154706315663127, 0.0],
            [-106.598526583829909, 52.154718043965651, 0.0],
            [-106.598526000195648, 52.154729796323892, 0.0],
            [-106.598525785048423, 52.15474156119722, 0.0],
            [-106.598525310319729, 52.154981152449949, 0.0],
            [-106.598524902239276, 52.155002232151318, 0.0],
            [-106.598523793936863, 52.155023286652977, 0.0],
            [-106.598521986641558, 52.155044292700033, 0.0],
            [-106.598519482344258, 52.155065227094376, 0.0],
            [-106.598516283813467, 52.155086066713011, 0.0],
            [-106.598512394580737, 52.155106788542625, 0.0],
            [-106.598507818946359, 52.15512736969665, 0.0],
            [-106.598505597865284, 52.155134503935486, 0.0],
            [-106.598502882479877, 52.155141465061256, 0.0],
            [-106.598499686144336, 52.155148218875176, 0.0],
            [-106.598496024551409, 52.15515473219056, 0.0],
            [-106.598491915690815, 52.155160973012237, 0.0],
            [-106.598487379756975, 52.155166910675682, 0.0],
            [-106.59848243902168, 52.155172516007092, 0.0],
            [-106.598477117777207, 52.155177761471649, 0.0],
            [-106.598471442156011, 52.155182621295964, 0.0],
            [-106.598471892265977, 52.155250043900864, 0.0],
            [-106.598473649870698, 52.155513309257536, 0.0],
            [-106.598473999574693, 52.155565689709455, 0.0],
            [-106.598482038367806, 52.155570309949923, 0.0],
            [-106.598489785912065, 52.155575403517155, 0.0],
            [-106.598497214370568, 52.155580952110533, 0.0],
            [-106.598504297053282, 52.15558693579441, 0.0],
            [-106.598511008513, 52.155593333069184, 0.0],
            [-106.5985173246372, 52.155600120955562, 0.0],
            [-106.59852322273899, 52.155607275061861, 0.0],
            [-106.598528681621687, 52.155614769687105, 0.0],
            [-106.59853368167893, 52.155622577905817, 0.0],
            [-106.598544317394968, 52.155642976981504, 0.0],
            [-106.59855343693792, 52.155664097460445, 0.0],
            [-106.598560991729741, 52.155685826839537, 0.0],
            [-106.598566941524027, 52.155708049365778, 0.0],
            [-106.598571254630343, 52.155730646661155, 0.0],
            [-106.5985739080743, 52.155753498355658, 0.0],
            [-106.5985748877183, 52.155776482719979, 0.0],
            [-106.598571113279633, 52.157683194415846, 0.0],
            [-106.59857089969168, 52.157693652396055, 0.0],
            [-106.598570319284079, 52.157704096439375, 0.0],
            [-106.598569372777987, 52.157714513688909, 0.0],
            [-106.598568061330283, 52.157724891310856, 0.0],
            [-106.598566386556229, 52.157735216526817, 0.0],
            [-106.598564350525834, 52.157745476621066, 0.0],
            [-106.598561955739797, 52.157755658955359, 0.0],
            [-106.59853096641109, 52.157878508029292, 0.0],
            [-106.598527939024137, 52.157891380033156, 0.0],
            [-106.598525365153861, 52.157904350337951, 0.0],
            [-106.598523247972466, 52.157917402966625, 0.0],
            [-106.598521590087316, 52.157930521845621, 0.0],
            [-106.598520393535679, 52.157943690816857, 0.0],
            [-106.598519659795642, 52.157956893665009, 0.0],
            [-106.598519389772918, 52.157970114129739, 0.0],
            [-106.598518792663185, 52.158271659362327, 0.0],
            [-106.598517964539141, 52.158289881695147, 0.0],
            [-106.598515837808222, 52.158307998432988, 0.0],
            [-106.598512423330234, 52.158325917154791, 0.0],
            [-106.59850773851575, 52.15834354643993, 0.0],
            [-106.598501807269926, 52.158360796352113, 0.0],
            [-106.59849465985063, 52.158377578890487, 0.0],
            [-106.598486332719276, 52.15839380843444, 0.0],
            [-106.598482836824445, 52.158399619426007, 0.0],
            [-106.598479024568022, 52.158405227956827, 0.0],
            [-106.598474907641489, 52.158410616817484, 0.0],
            [-106.598470498673109, 52.158415769477863, 0.0],
            [-106.598465811188888, 52.158420670132763, 0.0],
            [-106.598460859568917, 52.15842530374556, 0.0],
            [-106.598455659007755, 52.158429656107437, 0.0],
            [-106.598454856213294, 52.158486770918209, 0.0],
            [-106.598545693242315, 52.158792028048232, 0.0],
            [-106.598533930954858, 52.158801810922014, 0.0],
            [-106.598522658260322, 52.158816476247942, 0.0],
            [-106.598522939227323, 52.158842456804216, 0.0],
            [-106.598539976780458, 52.158894496663422, 0.0],
            [-106.598544876347987, 52.158915562698745, 0.0],
            [-106.598545041713649, 52.158933469854439, 0.0],
            [-106.598541832198165, 52.159096198291046, 0.0],
            [-106.598540377485989, 52.159291059353123, 0.0],
            [-106.598537247871079, 52.159490274749409, 0.0],
            [-106.598537713726529, 52.15965555847464, 0.0],
            [-106.598545121206712, 52.15983320850718, 0.0],
            [-106.598558397094834, 52.159993618811782, 0.0],
            [-106.598574065161856, 52.160150210288968, 0.0],
            [-106.598580398259656, 52.160263859202892, 0.0],
            [-106.598580349753689, 52.160361059853599, 0.0],
            [-106.598565616659172, 52.160515456538604, 0.0],
            [-106.598554864576585, 52.160619360666445, 0.0],
            [-106.59854638754463, 52.160742931321515, 0.0],
            [-106.598545272378786, 52.160917929775046, 0.0],
            [-106.59855555039141, 52.16113887729572, 0.0],
            [-106.598565134030508, 52.161318628398476, 0.0],
            [-106.59857143460809, 52.161517920488215, 0.0],
            [-106.598569932279602, 52.161641366593273, 0.0],
            [-106.598566432073582, 52.161754243736745, 0.0],
            [-106.598557079410938, 52.16192262881124, 0.0],
            [-106.598561298523961, 52.162087150700614, 0.0],
            [-106.598568815083013, 52.162242874990881, 0.0],
            [-106.598577800871141, 52.162365447791245, 0.0],
            [-106.598578795627958, 52.1624395903522, 0.0],
            [-106.598570068837276, 52.162546406880757, 0.0],
            [-106.598561735663253, 52.162624691876864, 0.0],
            [-106.598545801385484, 52.162762681791492, 0.0],
            [-106.598539898088674, 52.162852560715265, 0.0],
            [-106.598534557280189, 52.162950051732174, 0.0],
            [-106.598527419435911, 52.163066030522998, 0.0],
            [-106.598521651646635, 52.163187544170079, 0.0],
            [-106.598523369942939, 52.163288169725611, 0.0],
            [-106.598526130114536, 52.163351876773817, 0.0],
            [-106.598533263503057, 52.163401695313446, 0.0],
            [-106.598536770291332, 52.163433340275049, 0.0],
            [-106.598529509504019, 52.163444306162049, 0.0],
            [-106.59852156890156, 52.163454790271373, 0.0],
            [-106.598512980359359, 52.16346475052341, 0.0],
            [-106.598503778342987, 52.163474146942455, 0.0],
            [-106.598493999794286, 52.163482941808972, 0.0],
            [-106.59848368395977, 52.163491099825471, 0.0],
            [-106.598472872241473, 52.163498588247478, 0.0],
            [-106.598461608037482, 52.163505377019604, 0.0],
            [-106.59844993655733, 52.16351143889306, 0.0],
            [-106.598461577301734, 52.163519049104558, 0.0],
            [-106.598460906494083, 52.16383730911371, 0.0],
            [-106.598467735067103, 52.163840615313525, 0.0],
            [-106.598474493949922, 52.163844061736214, 0.0],
            [-106.598481180266376, 52.163847646916103, 0.0],
            [-106.598487791168722, 52.163851369323304, 0.0],
            [-106.598494323841166, 52.163855227373475, 0.0],
            [-106.598500775499858, 52.16385921942237, 0.0],
            [-106.598507143394045, 52.163863343769258, 0.0],
            [-106.59851566596555, 52.163869252116129, 0.0],
            [-106.598523821579832, 52.163875657483949, 0.0],
            [-106.59853158129043, 52.163882537139209, 0.0],
            [-106.598538917562095, 52.163889866662423, 0.0],
            [-106.598545804350536, 52.163897620042043, 0.0],
            [-106.5985522172152, 52.16390576975995, 0.0],
            [-106.598558133397802, 52.163914286892755, 0.0],
            [-106.598567512820665, 52.16392985821853, 0.0],
            [-106.598575899476529, 52.163945985951635, 0.0],
            [-106.598583260492873, 52.163962606880879, 0.0],
            [-106.598589567012809, 52.163979655855648, 0.0],
            [-106.598594794322693, 52.163997066054428, 0.0],
            [-106.598598921929792, 52.164014769234193, 0.0],
            [-106.598601933660504, 52.164032696008711, 0.0],
            [-106.598603817710028, 52.164050776112113, 0.0],
            [-106.598604566686404, 52.16406893867758, 0.0],
            [-106.598603573573058, 52.164970349040608, 0.0],
            [-106.598624675795307, 52.165682084738059, 0.0],
            [-106.598622572451589, 52.167523604127034, 0.0],
            [-106.598622202426611, 52.16754833348633, 0.0],
            [-106.598621168597148, 52.167573043999255, 0.0],
            [-106.59861947170792, 52.167597717845631, 0.0],
            [-106.598617112980705, 52.167622337241475, 0.0],
            [-106.598614094114438, 52.167646884431633, 0.0],
            [-106.598610417292491, 52.167671341724336, 0.0],
            [-106.598606085163908, 52.167695691484447, 0.0],
            [-106.598588735871246, 52.167786464977425, 0.0],
            [-106.598584036136486, 52.167812880775529, 0.0],
            [-106.59858004731592, 52.167839413227732, 0.0],
            [-106.598576772277724, 52.167866043211681, 0.0],
            [-106.598574213385277, 52.167892751524043, 0.0],
            [-106.598572372483034, 52.167919518907176, 0.0],
            [-106.598571250900164, 52.167946326069142, 0.0],
            [-106.598570849444229, 52.167973153678965, 0.0],
            [-106.598570355257863, 52.168406188437942, 0.0],
            [-106.598570192654321, 52.16840922574373, 0.0],
            [-106.59856983398717, 52.168412246178391, 0.0],
            [-106.598569280766228, 52.1684152370999, 0.0],
            [-106.598568535297076, 52.168418185989132, 0.0],
            [-106.59856760070474, 52.168421080502426, 0.0],
            [-106.598566480908218, 52.168423908526151, 0.0],
            [-106.598565180583321, 52.168426658219829, 0.0],
            [-106.59848711950076, 52.168474336857045, 0.0],
            [-106.598484205084773, 52.16847484967716, 0.0],
            [-106.59848128274723, 52.168475315259457, 0.0],
            [-106.598478353258528, 52.168475733486041, 0.0],
            [-106.598475417384165, 52.168476104245194, 0.0],
            [-106.598472475895392, 52.16847642744051, 0.0],
            [-106.598469529561939, 52.168476702989075, 0.0],
            [-106.598466579150497, 52.168476930813675, 0.0],
            [-106.598496116137554, 52.168541056828658, 0.0],
            [-106.598494148324548, 52.168762496627309, 0.0],
            [-106.598492279744008, 52.168802928491729, 0.0],
            [-106.598445708879652, 52.168837607641152, 0.0],
            [-106.59780704178111, 52.168846261376039, 0.0],
            [-106.597808864171412, 52.169093504657397, 0.0],
            [-106.597815474466088, 52.169990267964977, 0.0],
            [-106.597813110649057, 52.171996868903207, 0.0],
            [-106.598624547615316, 52.171997227348307, 0.0],
            [-106.598623451268139, 52.17294301564138, 0.0],
            [-106.597928979134451, 52.17294049673567, 0.0],
            [-106.597928247391351, 52.173552439378561, 0.0],
            [-106.597903692402383, 52.173776433329266, 0.0],
            [-106.597864119845411, 52.173998267163448, 0.0],
            [-106.597809709131965, 52.174216935203724, 0.0],
            [-106.597740706922181, 52.174431446117516, 0.0],
            [-106.597657426038481, 52.174640827426622, 0.0],
            [-106.597560244037581, 52.174844129898695, 0.0],
            [-106.597449601489629, 52.175040431869995, 0.0],
            [-106.597325999988229, 52.175228843405414, 0.0],
            [-106.59718999988398, 52.175408510345726, 0.0],
            [-106.597042217730618, 52.175578618171123, 0.0],
            [-106.59688332349468, 52.175738395701039, 0.0],
            [-106.596714037521437, 52.175887118588427, 0.0],
            [-106.596535127264445, 52.176024112596757, 0.0],
            [-106.596347403820459, 52.176148756666379, 0.0],
            [-106.596151718218536, 52.176260485728129, 0.0],
            [-106.584087509271157, 52.183968699834793, 0.0],
            [-106.58380680334524, 52.184140682429543, 0.0],
            [-106.583538594220684, 52.184331569033859, 0.0],
            [-106.5832841528172, 52.184540455131348, 0.0],
            [-106.583044684804904, 52.184766350905186, 0.0],
            [-106.582821324911478, 52.185008185948384, 0.0],
            [-106.58261513153046, 52.185264814317627, 0.0],
            [-106.582427081713817, 52.185535019973024, 0.0],
            [-106.582258066540803, 52.185817522542486, 0.0],
            [-106.582108886892186, 52.186110983379805, 0.0],
            [-106.581980249663346, 52.186414011915886, 0.0],
            [-106.581872764400444, 52.186725172239925, 0.0],
            [-106.581192149390034, 52.18946935324044, 0.0],
            [-106.577919132720993, 52.189348816628105, 0.0],
            [-106.577919080394423, 52.189492602909681, 0.0],
            [-106.575247002751709, 52.189485604042368, 0.0],
            [-106.575246772863792, 52.189250332733351, 0.0],
            [-106.560611171275227, 52.188709887849065, 0.0],
            [-106.560078480691104, 52.188699790048318, 0.0],
            [-106.559547940186661, 52.18865092284878, 0.0],
            [-106.559022367662678, 52.188563545803838, 0.0],
            [-106.558504554621308, 52.188438123002918, 0.0],
            [-106.557997251351466, 52.188275320613677, 0.0],
            [-106.557503152322155, 52.188076003334565, 0.0],
            [-106.5570248818767, 52.187841229813777, 0.0],
            [-106.556564980273819, 52.187572247017663, 0.0],
            [-106.556125890221068, 52.187270483610433, 0.0],
            [-106.555709943887436, 52.186937542365754, 0.0],
            [-106.555319350503552, 52.18657519165626, 0.0],
            [-106.553622830833902, 52.184518674754976, 0.0],
            [-106.553491059760333, 52.184353044400538, 0.0],
            [-106.553371571973955, 52.184178345522888, 0.0],
            [-106.553264989270232, 52.183995487228451, 0.0],
            [-106.553171866285979, 52.183805421085701, 0.0],
            [-106.553092687618161, 52.183609136168307, 0.0],
            [-106.553027865310057, 52.18340765391649, 0.0],
            [-106.552977736679665, 52.18320202281533, 0.0],
            [-106.552907444670197, 52.182830497262131, 0.0],
            [-106.551385287519324, 52.182942168503303, 0.0]
          ]
        }
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/assets/geojson/ncp-data.js